document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rv-guide a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var id = link.getAttribute('href');

      if (!id || id === '#') {
        return;
      }

      var target = document.querySelector(id);

      if (!target) {
        return;
      }

      event.preventDefault();

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
});
